<template lang="pug">
  .Logo_diamonds(@mouseenter="headerLogoPlay")
    .Logo_diamond(ref="diamondBack")
      .Logo_diamond_pattern(:style="patternBackStyle")
    .Logo_diamond(ref="diamondFront")
      .Logo_diamond_pattern(:style="patternFrontStyle")
</template>

<script>

import {TweenLite, TimelineLite} from 'gsap'

export default {
  props: ['isLoader'],
  data () {
    return {
      headerLogo: false,
      patternFrontIndex: 0,
      patternBackIndex: 0,
      beingPlayed: false
    }
  },
  computed: {
    patternFrontStyle () {
      const bgPosY = Math.round(100 / 6 * (this.patternFrontIndex % 6) * 1000) / 1000
      return {
        backgroundPosition: `0 ${bgPosY}%`
      }
    },
    patternBackStyle () {
      const bgPosY = 100 - Math.round(100 / 6 * (this.patternBackIndex % 6) * 1000) / 1000
      return {
        backgroundPosition: `0 ${bgPosY}%`
      }
    }
  },
  mounted () {
    // On commence l'animation du loader
    if (this.isLoader) { this.start() }
  },
  beforeDestroy () {
    // On arrête l'animation du loader au cas où
    this.stop()
  },
  methods: {
    start (header = false) {
      this.headerLogo = header
      this.stop()
      this.initLoadingAnimation()
    },
    stop () {
      this.killLoadingAnimation()
    },
    /**
     * Initialasition de l'animation du loading
     */
    initLoadingAnimation () {
      const timeline = new TimelineLite({
          onComplete: () => { if (!this.headerLogo) { this._animTimeline.play('restart') } }
        }),
        distance = 37,
        easeExpand = Power3.easeIn,
        speedExpand = 0.8,
        easeRetract = Power3.easeOut,
        speedRetract = 1,
        {diamondBack, diamondFront} = this.$refs,
        getShadow = (position = 'middle', visible = false) => {
          let shadowPos = 0
          const shadowBlur = visible ? 10 : 0

          switch (position) {
            case 'top':
              shadowPos = 3
              break
            case 'bottom':
              shadowPos = -3
              break
            default:
              shadowPos = 0
              break
          }

          return `${shadowPos}px ${shadowPos}px ${shadowBlur}px blue`
        }

      // Set only once
      // Initial position
      if (this.headerLogo) {
        TweenLite.set(diamondBack, {
          opacity: 1,
          y: distance / 3
        })

        TweenLite.set(diamondFront, {
          opacity: 1,
          y: -distance / 3
        })
      } else {
        TweenLite.set(diamondBack, {
          opacity: 0,
          y: distance / 3
        })

        TweenLite.set(diamondFront, {
          opacity: 0,
          y: -distance / 3
        })
      }

      // Création de la timeline d'animation
      timeline
        // Expand
        .add([
          TweenLite.to(diamondBack, speedExpand, {
            opacity: 1,
            y: distance,
            ease: easeExpand
          }),
          TweenLite.to(diamondFront, speedExpand, {
            opacity: 1,
            y: -distance,
            ease: easeExpand
          })
        ])
        .addLabel('restart')
        // Swap indexes
        .set(diamondBack, {
          zIndex: 1
        })
        .set(diamondFront, {
          zIndex: 0
        })
        // retract
        .add([
          TweenLite.to(diamondBack, speedRetract, {
            y: distance / 3,
            scale: 1,
            ease: easeRetract
          }),
          TweenLite.to(diamondFront, speedRetract, {
            y: -distance / 3,
            scale: 0.9,
            ease: easeRetract
          })
        ])
        // Pause
        .delay(0.3)
        // Extand again
        .add([
          TweenLite.to(diamondBack, speedExpand, {
            y: -distance,
            scale: 1,
            ease: easeExpand
          }),
          TweenLite.to(diamondFront, speedExpand, {
            y: distance,
            scale: 1,
            ease: easeExpand
          })
        ])
        .call(() => this.patternFrontIndex = this.patternFrontIndex + 1, null, null, `-=${speedExpand * 0.3}`)
        // Swap indexes again
        .set(diamondBack, {
          zIndex: 0
        })

        .set(diamondFront, {
          zIndex: 1
        })
        // Retract again (back to initial position)
        .add([
          TweenLite.to(diamondBack, speedRetract, {
            y: -distance / 3,
            scale: 0.9,
            ease: easeRetract
          }),
          TweenLite.to(diamondFront, speedRetract, {
            y: distance / 3,
            scale: 1,
            ease: easeRetract
          })
        ])
      if (this.headerLogo) {
        timeline.add([
          TweenLite.to(diamondBack, speedRetract, {
            y: distance / 3,
            scale: 1,
            ease: easeRetract
          }),
          TweenLite.to(diamondFront, speedRetract, {
            y: -distance / 3,
            scale: 1,
            ease: easeRetract
          })
        ])
      } else {
        timeline.add([
          TweenLite.to(diamondBack, speedExpand, {
            y: distance,
            scale: 1,
            ease: easeExpand
          }),
          TweenLite.to(diamondFront, speedExpand, {
            y: -distance,
            scale: 1,
            ease: easeExpand
          })
        ])
          .call(() => this.patternBackIndex = this.patternBackIndex + 1, null, null, `-=${speedExpand * 0.3}`)
      }

      this._animTimeline = timeline
    },
    /**
     * Arrêt de l'animation du loading
     */
    killLoadingAnimation () {
      // S'il y a une animation
      if (this._animTimeline) {
        // On l'arrête
        this._animTimeline.kill()
        this._animTimeline = null
      }
    },
    headerLogoPlay () {
      if (!this.beingPlayed) {
        this.beingPlayed = true
        this._animTimeline.play(0).eventCallback('onComplete', () => { this.beingPlayed = false })
      }
    },
    /**
     * Animation de disparition du composant
     */
    leave (done) {
      const {diamondBack, diamondFront} = this.$refs

      this.killLoadingAnimation()

      TweenLite.to(diamondBack, 1, {
        opacity: 0,
        scale: 1,
        y: 0
      }, 0)

      TweenLite.to(diamondFront, 1, {
        opacity: 0,
        scale: 1,
        y: 0
      }, 0)

      // TODO - changer ça ?
      // QUICK HACK - Simple delay de disparition
      // Permet que le préolader reste visible pendant la transition de page
      // avant de disparaitre d'un seul coup
      setTimeout(done, 3000)
    }
  }
}

</script>

<style lang="stylus" scope>

.Logo_diamonds

  // background red
  width 100px
  height 200px

  .Logo_diamond
    position: absolute
    top 50%
    left 50%
    height 0
    width 0
    overflow visible

    &_pattern
      content ''
      position: absolute
      top 0
      left 0
      width 70px
      max-width @width
      height @width
      max-height @width
      box-sizing border-box
      transform translate(-50%, -50%) rotate(45deg)
      background-image url('/img/logos/logo-patterns.jpg')
      background-position 0 0
      background-size 100% auto
      background-repeat no-repeat
      background-color black

</style>
